import Navbar from '../components/Navbar';
import StartContent from '../components/Start/StartContent';

export default function Start() {
  return (
    <>
      <Navbar />
      <StartContent />
    </>
  );
}
